// removed by extract-text-webpack-plugin
module.exports = {"row":"wmf-18f2BSlq","turnRight":"wmf-1r6Mgk0H","marginR10":"wmf-3lijPys1","container":"wmf-3msTYF22","key":"wmf-OqMrr1bN","matchlist":"wmf-3OTUyUKu"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/billVerification/createBills/artificialCreate/index.module.less
// module id = 4736
// module chunks = 0